module.exports = __webpack_public_path__ + "static/media/css.989a735c.svg";